import { setGeoCoordsCookie } from 'cookies/geoCoordsCookie'
import { getCurrentIntl } from 'i18n/util/currentIntl'

function getCurrentGeoLocation(): Promise<GeolocationCoordinates> {
  if (!navigator?.geolocation) {
    const intl = getCurrentIntl()
    return Promise.reject(intl.formatMessage({
      id: 'I924kq3B_Hxy1n2OmwJZ',
      defaultMessage: 'Not supported by client',
      description: 'Error message when the browser does not support geolocation services',
    }))
  }

  return new Promise<GeolocationCoordinates>((resolve, reject) => {
    navigator.geolocation.getCurrentPosition((position) => {
      setGeoCoordsCookie(position.coords.latitude, position.coords.longitude)
      resolve(position.coords)
    }, (reason) => {
      const intl = getCurrentIntl()
      if (reason.PERMISSION_DENIED) {
        reject(intl.formatMessage({
          id: 'e13cI5bj8Bi_sflplOdA',
          defaultMessage: 'We couldn’t determine your location as we don’t have permission, please allow access.',
          description: 'Snackbar error message when geolocation permission is denied by the browser',
        }))
      } else if (reason.POSITION_UNAVAILABLE) {
        reject(intl.formatMessage({
          id: '_Lrr2duIo_nnrlTCfrpP',
          defaultMessage: 'We couldn’t determine your location, it looks like positioning services are unavailable.',
          description: 'Snackbar error message when geolocation positioning services are unavailable',
        }))
      } else if (reason.TIMEOUT) {
        reject(intl.formatMessage({
          id: 'JZyWlZKRCj7PBl-dEqYm',
          defaultMessage: 'We couldn’t determine your location, something went wrong.',
          description: 'Snackbar error message when geolocation request times out',
        }))
      }
    })
  })
}

export default getCurrentGeoLocation
